module.exports = __webpack_public_path__ + "static/stakeholders-46c13569aefb6048093836fd9d22f945.png";